import { FormType } from '../../../form-types';
import { AlcoholFieldAnswers } from '../questions';

const alcoholFollowup: FormType<AlcoholFieldAnswers> = {
  name: 'Alcohol Follow up',
  questions: [
    'alcoholFollowup_sexAssignedAtBirth',
    'alcoholFollowup_heightFeet',
    'alcoholFollowup_weightPounds',
    {
      key: 'alcoholFollowup_healthChanges',
      next: {
        condition: {
          'alcoholFollowup_healthChanges.yes': true
        },
        key: 'alcoholFollowup_healthChangesDetails',
        els: 'alcoholFollowup_medicationEffectOnDrinking'
      }
    },
    'alcoholFollowup_healthChangesDetails',
    {
      key: 'alcoholFollowup_medicationEffectOnDrinking',
      next: {
        condition: {
          'alcoholFollowup_medicationEffectOnDrinking.stopped': true
        },
        key: 'alcoholFollowup_timespanOfSingleDrink',
        els: 'alcoholFollowup_drinksConsumedPerWeekDay'
      }
    },
    'alcoholFollowup_drinksConsumedPerWeekDay',
    'alcoholFollowup_drinksConsumedPerWeekendDay',
    'alcoholFollowup_timespanOfSingleDrink',
    'alcoholFollowup_cravingsFromCues',
    'alcoholFollowup_cravingsFromOthersDrinking',
    {
      key: 'alcoholFollowup_sideEffects',
      next: {
        condition: {
          'alcoholFollowup_sideEffects.yes': true
        },
        key: 'alcoholFollowup_sideEffectsDetails',
        els: 'alcoholFollowup_continueTreatment'
      }
    },
    'alcoholFollowup_sideEffectsDetails',
    'alcoholFollowup_continueTreatment',
    'alcoholFollowup_questionsForDoctor',
    {
      key: 'alcoholFollowup_truthfulness',
      next: {
        condition: {
          'alcoholFollowup_truthfulness.consent': true
        },
        key: 'alcoholFollowup_pharmacotherapy',
        els: 'alcoholFollowup_ineligible'
      }
    },
    {
      key: 'alcoholFollowup_pharmacotherapy',
      next: {
        condition: {
          'alcoholFollowup_pharmacotherapy.consent': true
        },
        key: 'alcoholFollowup_complete',
        els: 'alcoholFollowup_ineligible'
      }
    },
    'alcoholFollowup_ineligible',
    'alcoholFollowup_complete'
  ]
};

export default alcoholFollowup;
